import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import NAV from "../../utils/nav.const";
import theme from "../../styles/styleTheme";

type ComplexSidebarItemProps = {
  property: any;
};

const ComplexSidebarItem = ({ property }: ComplexSidebarItemProps) => {
  const [expanded, setExpanded] = useState<string | false>(false);
  const location = useLocation();

  const handleChange =
    (panel: any) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <>
      {(property?.properties == null || property?.properties.length === 0) && (
        <Box
          style={{
            paddingRight: 0
          }}
        >
          <Box
            component={Link}
            to={`/${NAV.PROPERTY_DETAILS}/${property?.urlSlug}`}
            sx={{
              padding: "1rem",
              display: "block",
              color: "#000",
              borderBottom: "1px solid transparent",
              textDecoration: "none",
              transition: "color 0.15s ease",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: theme.palette.secondary.light,
                color: theme.palette.secondary.main,
              },
            }}
          >
            <Typography variant="body2" fontWeight={"bold"}>{property.title}</Typography>
          </Box>
        </Box>
      )}
      {property?.properties?.length > 0 && (
        <Box>
          <Accordion
            key={property.id}
            expanded={expanded === property.title}
            onChange={handleChange(property.title)}
            sx={{
              boxShadow: "none",
              "&:before": {
                display: "none",
              },
              "&:not(:first-of-type) .MuiAccordionSummary-root": {
                marginTop: "16px",
              },
            }}
          >
            <AccordionSummary
              key={property.id}
              expandIcon={<ExpandMoreIcon />}
              sx={{
                borderRadius: "8px",
                '&:hover': {
                  backgroundColor: theme.palette.secondary.light,
                  color: theme.palette.secondary.main,
                },
              }}
            >
              <Typography variant="body2" fontWeight={"bold"}>{property.title}</Typography>
            </AccordionSummary>
            <AccordionDetails key={property.id}>
              <>
                {property?.properties?.map((childProperty: any) => {
                  return (
                    <ComplexSidebarItem
                      key={childProperty.id}
                      property={childProperty}
                    />
                  );
                })}
              </>
            </AccordionDetails>
          </Accordion>
        </Box>
      )}
    </>
  );
};

export default ComplexSidebarItem;
